import React, { useState } from "react";
import "./Nav.css";
import { AiOutlineHome, AiOutlineUser, AiOutlineMessage } from "react-icons/ai";
import { RiServiceLine } from "react-icons/ri";
import { TbWalletOff, TbFileCertificate } from "react-icons/tb";
import { MdOutlineWorkHistory } from "react-icons/md";
import { RiEnglishInput } from "react-icons/ri";
import "react-tooltip/dist/react-tooltip.css";
import Ar from "../../assets/ar.png";
import fr from "../../assets/fr2.png";
import en from "../../assets/eng.png";

import i18n from "../../languages/i18n";

import { Tooltip as ReactTooltip } from "react-tooltip";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");
  const [direction, setDirection] = useState("ltr");
  return (
    <nav dir={direction}>
      <a
        href="#"
        onClick={() => {
          setActiveNav("#");
        }}
        className={activeNav == "#" && "active"}
        id="homeMenu"
      >
        <AiOutlineHome size={30} />
      </a>

      <a
        href="#about"
        onClick={() => setActiveNav("#about")}
        className={activeNav == "#about" && "active"}
        id="aboutMenu"
      >
        {" "}
        <AiOutlineUser size={30} />{" "}
      </a>
      <a
        href="#experience"
        onClick={() => setActiveNav("#experience")}
        className={activeNav == "#experience" && "active"}
        id="experienceMenu"
      >
        {" "}
        <MdOutlineWorkHistory size={30} />{" "}
      </a>
      <a
        href="#portfolio"
        onClick={() => setActiveNav("#portfolio")}
        className={activeNav == "#portfolio" && "active"}
        id="portfolioMenu"
      >
        {" "}
        <TbWalletOff size={30} />{" "}
      </a>
      <a
        href="#services"
        onClick={() => setActiveNav("#services")}
        className={activeNav == "#services" && "active"}
        id="serviceMenu"
      >
        {" "}
        <RiServiceLine size={30} />{" "}
      </a>
      <a
        href="#testimonials"
        onClick={() => setActiveNav("#testimonials")}
        className={activeNav == "#testimonials" && "active"}
        id="testMenu"
      >
        {" "}
        <TbFileCertificate size={30} />{" "}
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav == "#contact" && "active"}
        id="contactMenu"
      >
        {" "}
        <AiOutlineMessage size={30} />{" "}
      </a>
      <div className="separator"></div>
      {/**language btn............ */}

      <div className="language-container">
        <a
          href="#"
          onClick={() => {
            i18n.changeLanguage("en");
            const dir = i18n.dir(i18n.language);
            document.documentElement.dir = dir;
            setDirection("ltr");
            //document.body.style.width = "100vw";
          }}
          id="engMenu"
        >
          <img src={en} alt="English" className="languege-icon" />
        </a>
        <a
          href="#"
          onClick={() => {
            i18n.changeLanguage("fr");
            const dir = i18n.dir(i18n.language);
            document.documentElement.dir = dir;
            setDirection("ltr");
            //document.body.style.width = "100vw";
          }}
          id="frMenu"
        >
          <img src={fr} alt="French" className="languege-icon" />
        </a>
        <a
          href="#"
          onClick={() => {
            i18n.changeLanguage("ar");
            const dir = i18n.dir(i18n.language);
            document.documentElement.dir = dir;
            setDirection("rtl");
            //document.body.style.width = "100vw";
          }}
          id="arMenu"
        >
          <img src={Ar} alt="Arabic" className="languege-icon" />
        </a>
      </div>

      <ReactTooltip anchorId="homeMenu" place="right-end" content="Home" />
      <ReactTooltip anchorId="aboutMenu" place="right-end" content="About" />
      <ReactTooltip
        anchorId="experienceMenu"
        place="right-end"
        content="Experience"
      />
      <ReactTooltip
        anchorId="portfolioMenu"
        place="right-end"
        content="Portfolio"
      />
      <ReactTooltip
        anchorId="serviceMenu"
        place="right-end"
        content="Services"
      />
      <ReactTooltip
        anchorId="testMenu"
        place="right-end"
        content="Testimonial"
      />
      <ReactTooltip
        anchorId="contactMenu"
        place="right-end"
        content="Contact"
      />
      <ReactTooltip anchorId="engMenu" place="right-end" content="English" />
      <ReactTooltip anchorId="arMenu" place="right-end" content="عربي" />
      <ReactTooltip anchorId="frMenu" place="right-end" content="Francais" />
    </nav>
  );
};

export default Nav;
